<script setup>
import IlluminatedButton from '@/components/buttons/IlluminatedButton.vue';

defineProps({
  label: {
    type: String,
    default: 'Envoyer',
  },
  isSubmitting: {
    type: Boolean,
    required: true,
  },
});
</script>

<template>
   <IlluminatedButton
      :label="isSubmitting ? 'Envoi en cours...' : label"
      class="points-container__button"
      type="submit"
      :disabled="isSubmitting"
   />

</template>

<style scoped>
button {
  padding: 0.75rem 1.5rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  color: #FFF;
  transition: background-color 0.2s;
}

button:hover:not(:disabled) {
  background-color: #0056b3;
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>
